var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animate-route"},[_c('details-info',{attrs:{"title":_vm.decorInfo.flowerTitle,"scale":"","imgSrc":_vm.imgUrl + _vm.decorInfo.detailsImg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }